import React from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { Route } from '~services/RoutesService';
import Flags from '~screens/Dashboard/screens/Projects/components/Flags';

import styles from './styles.module.scss';

interface Props {
  territory: Route;
  /** Highlights the territory's polygon on the map while the pointer or focus is on the card. */
  onHighlight: (id?: number) => void;
}

/** Map panel row for a territory: flag, name and "N Acciones"; opens the territory's map, handing it the territory so it can draw before its Acciones load. */
const TerritoryCard = ({ territory, onHighlight }: Props) => {
  const countries = (territory.countriesFormatted || '').split(',').map(name => name.trim()).filter(Boolean);
  const highlight = () => onHighlight(territory.id);
  const clear = () => onHighlight(undefined);

  return (
    <Link
      to={`/territories/${territory.id}/show/map`}
      state={{ territory }}
      className={styles.card}
      onMouseEnter={highlight}
      onMouseLeave={clear}
      onFocus={highlight}
      onBlur={clear}
    >
      <span className={styles.body}>
        <span className={styles.header}>
          <span className={styles.flags}><Flags countries={countries} /></span>
          <span className={styles.name}>{territory.name}</span>
        </span>
        <span className={styles.count}>
          <span className={styles.number}>{territory.actions}</span>
          <span className={styles.label}>{i18next.t('map:projects')}</span>
        </span>
      </span>
      <ChevronRightIcon className={styles.chevron} fontSize="large" aria-hidden />
    </Link>
  );
};

export default TerritoryCard;
